import { makeStyles, mergeClasses, shorthands } from "@fluentui/react-components";

import { themeTokens } from "Core/Theme";
import { StyleConstants } from "Shared/Styles/StyleConstants";

const AppLeftBarMainStyles = makeStyles({
    root: {
        backgroundColor: themeTokens.colorNeutralBackground3,
        height: "100%",
        textAlign: "center"
    },
    separator: {
        ...shorthands.borderTop("1px", "solid", themeTokens.colorNeutralStroke1),
        ...shorthands.margin("0 auto"),
        width: "50px"
    },
    separatorContainer: {
        display: "inline-block"
    },
    overflowContainer: {
        height: "100%"
    }
});

const useAppLeftBarSmallStyles = makeStyles({
    overflowContainer: {
        height: `calc(100vh - ${StyleConstants.headerHeight}px)`
    }
});

export const useAppLeftBarStyles = (isSmallScreen?: boolean) => {
    const styles = AppLeftBarMainStyles();
    const smallStyles = useAppLeftBarSmallStyles();

    styles.overflowContainer = mergeClasses(styles.overflowContainer, isSmallScreen && smallStyles.overflowContainer);

    return styles;
};
